<section class="card">

    <div class="card-header">
      <title>CHG-7 Register of Charges</title>
      <span class="cat__core__title">
        <strong id="pageTitle">CHG-7 Register of Charges</strong>
      </span>
      <span style="float: right">
        <!-- <a routerLink="/chg7List"> -->
          <button (click)="back()" class="btn btn-sm btn-default pull-right btn-back" type="button">
            <i class=" fa fa-chevron-circle-left"></i>
            Back
          </button>
        <!-- </a> -->
      </span>
      <!-- <span style="float:right">
          <button class="btn btn-success pull-right" class="btn btn-sm btn-primary" style="margin-right: 8px;" (click)="generateOutput()" type="button" *ngIf="restrictTabFlag">
            <span>
              <i class="fa fa-save"></i>Generate Output </span>
          </button>
  </span> -->
    </div>
  
    <div class="row">
      <div class="col-lg-12" id="chargeTabContainer">
        <ul class="nav nav-tabs" role="tablist">
          <li class="nav-item">
            <a class="nav-link active" href="javascript: void(0);" data-toggle="tab" data-target="#creation"
              [appHasPermission]="{'Url': '/register/director/edit?goveva=true&email=', 'method':'put', 'menu': 'Director'}"
              role="tab">Creation
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" *ngIf="restrictTabFlag" href="javascript: void(0);" data-toggle="tab"
              data-target="#modification"
              [appHasPermission]="{'Url': '/register/director/edit?goveva=true&email=', 'method':'put', 'menu': 'Director'}"
              role="tab">Modification
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" *ngIf="restrictTabFlag" href="javascript: void(0);" data-toggle="tab"
              data-target="#satisfaction"
              [appHasPermission]="{'Url': '/register/director/edit?goveva=true&email=', 'method':'put', 'menu': 'Director'}"
              role="tab">Satisfaction
            </a>
          </li>
  
  
  
        </ul>
  
        <div class="tab-content">
          <div class="tab-pane active" id="creation" role="tabcard">
            <form [formGroup]='chgForm' class="well" (document:click)="a.close();b.close();c.close()">
              <div class="modal-body">
                <div class="row">
                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label>Charge ID</label>
                    <span _ngcontent-c1="" style="color: red;">*</span><br><br>
                    <input type="text" class="form-control" [formControl]="chgForm.controls.chargeId">
  
                    <div *ngIf="chgForm.controls['chargeId'].hasError('required') && chgForm.controls['chargeId'].touched"
                      class="form-control-error-custom">
                      Charge ID is required
                    </div>
                    <div
                      *ngIf="(chgForm.controls['chargeId'].hasError('pattern')||chgForm.controls['chargeId'].hasError('maxlength')) && chgForm.controls['chargeId'].touched"
                      class="form-control-error-custom">
                      Charge ID is invalid
                    </div>
                  </div>
  
                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label>Date of creation of charge or date of acquisition of property subject to charge<span
                        _ngcontent-c1="" style="color: red;">*</span></label>
  
                    <div class="input-group" (click)="$event.stopPropagation()">
                      <input class="form-control" [formControl]="chgForm.controls['dateOfCreation']"
                        [(ngModel)]="dateOfCreationModel" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy"
                        name="creationdate" ngbDatepicker #a="ngbDatepicker" (click)="a.toggle()">
                      <button class="input-group-addon" (click)="a.toggle()" type="button">
                        <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                      </button>
                    </div>
                    <div
                      *ngIf="chgForm.controls['dateOfCreation'].hasError('required') && chgForm.controls['dateOfCreation'].touched"
                      class="form-control-error-custom">
                      Date of creation of charge or date of acquisition of property subject to charge is required
                    </div>
                  </div>
  
                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label>Date of registration of creation of charge</label><br><br>
                    <div class="input-group" (click)="$event.stopPropagation()">
                      <input class="form-control" [formControl]="chgForm.controls['dateOfRegistration']"
                        [(ngModel)]="dateOfRegistrationModel" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy"
                        name="registrationdate" ngbDatepicker #b="ngbDatepicker" (click)="b.toggle()">
                      <button class="input-group-addon" (click)="b.toggle()" type="button">
                        <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                      </button>
                    </div>
                  </div>
                </div>
  
                <div class="row">
                  <div class="form-group  col-md-4 col-sm-6 col-xs-12">
                    <label>Short description of the property charged</label>
                    <textarea class="form-control" [formControl]="chgForm.controls['shortDescriptionofproperty']"
                      maxlength="250"></textarea>
                    <div class="form-control-error-custom"
                      *ngIf="(chgForm.controls['shortDescriptionofproperty'].hasError('pattern')||chgForm.controls['shortDescriptionofproperty'].hasError('maxlength')) && chgForm.controls['shortDescriptionofproperty'].touched">
                      Short description of the property charged is invalid
                    </div>
                  </div>
  
                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label>Period secured by the charge (in months)</label>
                    <input type="text" class="form-control" [formControl]="chgForm.controls.periodSecured">
                    <div class="form-control-error-custom"
                      *ngIf="(chgForm.controls['periodSecured'].hasError('pattern')||chgForm.controls['periodSecured'].hasError('maxlength')) && chgForm.controls['periodSecured'].touched">
                      Period secured by the charge is invalid
                    </div>
                  </div>
  
                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label>Amount secured by the charge</label>
                    <span _ngcontent-c1="" style="color: red;">*</span>
                    <input type="text" class="form-control" [formControl]="chgForm.controls.amountSecured">
                    <div
                      *ngIf="chgForm.controls['amountSecured'].hasError('required') && chgForm.controls['amountSecured'].touched"
                      class="form-control-error-custom">
                      Amount secured by the charge is required
                    </div>
                    <div class="form-control-error-custom"
                      *ngIf="(chgForm.controls['amountSecured'].hasError('pattern')||chgForm.controls['amountSecured'].hasError('maxlength')) && chgForm.controls['amountSecured'].touched">
                      Amount secured by the charge is invalid
                    </div>
                  </div>
                </div>
  
                <div class="row">
                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label>Name of the Charge Holder</label>
                    <span _ngcontent-c1="" style="color: red;">*</span>
                    <input type="text" class="form-control" [formControl]="chgForm.controls.nameChargeHolder">
                    <div
                      *ngIf="(chgForm.controls['nameChargeHolder'].hasError('pattern')||chgForm.controls['nameChargeHolder'].hasError('maxlength')) && chgForm.controls['nameChargeHolder'].touched"
                      class="form-control-error-custom">
                      Name of the Charge Holder is invalid
                    </div>
                    <div
                      *ngIf="chgForm.controls['nameChargeHolder'].hasError('required') && chgForm.controls['nameChargeHolder'].touched"
                      class="form-control-error-custom">
                      Name of the Charge Holder is required
                    </div>
                  </div>
  
                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label>Address of the charge holder</label>
                    <textarea class="form-control" [formControl]="chgForm.controls['addressChargeHolder']"
                      maxlength="250"></textarea>
                    <div
                      *ngIf="(chgForm.controls['addressChargeHolder'].hasError('pattern')||chgForm.controls['addressChargeHolder'].hasError('maxlength')) && chgForm.controls['addressChargeHolder'].touched"
                      class="form-control-error-custom">
                      Address of the charge holder is invalid
                    </div>
                  </div>
  
                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label>Terms and conditions of the charge</label>
                    <textarea class="form-control" [formControl]="chgForm.controls['termsandCondition']"
                      maxlength="5000"></textarea>
                    <div
                      *ngIf="chgForm.controls['termsandCondition'].hasError('pattern')||chgForm.controls['termsandCondition'].hasError('maxlength')"
                      class="form-control-error-custom">
                      Terms and conditions of the charge is invalid
                    </div>
                  </div>
                </div>
  
                <div class="row">
                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label>Description of the instrument creating the charge</label>
                    <textarea class="form-control" [formControl]="chgForm.controls['descriptionOfInstrument']"
                      maxlength="5000"></textarea>
                    <div
                      *ngIf="(chgForm.controls['descriptionOfInstrument'].hasError('pattern')||chgForm.controls['descriptionOfInstrument'].hasError('maxlength')) && chgForm.controls['descriptionOfInstrument'].touched"
                      class="form-control-error-custom">
                      Description of the instrument creating the charge is invalid
                    </div>
                  </div>
  
                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label>Facts of condonation of delay, if any</label>
                    <input type="text" class="form-control" [formControl]="chgForm.controls.factsOfCondonation">
                    <div
                      *ngIf="(chgForm.controls['factsOfCondonation'].hasError('pattern')||chgForm.controls['factsOfCondonation'].hasError('maxlength')) && chgForm.controls['factsOfCondonation'].touched"
                      class="form-control-error-custom">
                      Facts of condonation of delay is invalid
                    </div>
                  </div>
  
                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label>Date of condonation of delay, if any</label>
                    <div class="input-group" (click)="$event.stopPropagation()">
                      <input class="form-control" [formControl]="chgForm.controls['dateOfCondonation']"
                        [(ngModel)]="dateOfCondonationModel" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy"
                        name="condonationdate" ngbDatepicker #c="ngbDatepicker" (click)="c.toggle()">
                      <button class="input-group-addon" (click)="c.toggle()" type="button">
                        <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                      </button>
                    </div>
                  </div>
                </div>
  
                <div class="row">
                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label>Reasons for delay in filing for registration of creation, modification or satisfaction of the
                      charge, if any</label>
                    <textarea class="form-control" [formControl]="chgForm.controls['reasonsForDelay']"
                      maxlength="250"></textarea>
                    <div
                      *ngIf="(chgForm.controls['reasonsForDelay'].hasError('pattern')||chgForm.controls['reasonsForDelay'].hasError('maxlength')) && chgForm.controls['reasonsForDelay'].touched"
                      class="form-control-error-custom">
                      Reasons for delay is invalid
                    </div>
                  </div>
                </div>
  
                <div class="card-footer" align="right">
                  <div class="form-group" *ngIf="!restrictTabFlag">
                    <button class="btn btn-sm btn-primary" (click)="saveFormEntryCreation()" type="button"
                      [disabled]="!(chgForm.valid) || disabledOnClick">
                      <span>
                        <i class="fa fa-save"></i>&nbsp;Save</span>
                    </button>
                  </div>
                  <div class="form-group" *ngIf="restrictTabFlag">
                    <button class="btn btn-sm btn-primary" (click)="updateChargeMaster(editChargeID._id)" type="button"
                      [disabled]="!(chgForm.valid) || disabledOnClick">
                      <span>
                        <i class="fa fa-save"></i>&nbsp;Update</span>
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
  
          <div class="tab-pane" id="modification" role="tabcard">
            <form [formGroup]='modForm' class="well" (document:click)="x.close();y.close()">
              <div class="modal-body">
                <div class="row">
                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label>Date of modification of charge</label>
                    <div class="input-group" (click)="$event.stopPropagation()">
                      <input class="form-control" [formControl]="modForm.controls['dateOfModification']"
                        [(ngModel)]="dateOfModification" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy"
                        name="modificationdate" ngbDatepicker #x="ngbDatepicker" (click)="x.toggle()">
                      <button class="input-group-addon" (click)="x.toggle()" type="button">
                        <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                      </button>
                    </div>
                  </div>
  
                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label>Date of registration of modification of charge</label>
                    <div class="input-group" (click)="$event.stopPropagation()">
                      <input class="form-control" [formControl]="modForm.controls['dateOfRegModification']"
                        [(ngModel)]="dateOfRegModification" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy"
                        name="regmodificationdate" ngbDatepicker #y="ngbDatepicker" (click)="y.toggle()">
                      <button class="input-group-addon" (click)="y.toggle()" type="button">
                        <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                      </button>
                    </div>
                  </div>
  
                  <div>
                    <label>Description of the instrument modifying the charge</label>
                    <textarea class="form-control" [formControl]="modForm.controls['descOfInstrumentModifying']"
                      maxlength="500"></textarea>
                    <div
                      *ngIf="(modForm.controls['descOfInstrumentModifying'].hasError('pattern')||modForm.controls['descOfInstrumentModifying'].hasError('maxlength')) && modForm.controls['descOfInstrumentModifying'].touched"
                      class="form-control-error-custom">
                      Description of the instrument modifying the charge is invalid
                    </div>
                  </div>
                </div>
  
                <div class="row">
                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label>Particulars of modification</label>
                    <input type="text" class="form-control" [formControl]="modForm.controls.particularsOfMod">
                    <div
                      *ngIf="(modForm.controls['particularsOfMod'].hasError('pattern')||modForm.controls['particularsOfMod'].hasError('maxlength')) && modForm.controls['particularsOfMod'].touched"
                      class="form-control-error-custom">
                      Particulars of modification is invalid
                    </div>
                  </div>
  
                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label>Amount of Charge after Modification</label>
                    <!-- <span _ngcontent-c1="" style="color: red;">*</span> -->
                    <input type="text" class="form-control" [formControl]="modForm.controls.amountOfCharge">
                    <!-- <div
                      *ngIf="modForm.controls['amountOfCharge'].hasError('required') && modForm.controls['amountOfCharge'].touched"
                      class="form-control-error-custom">
                      Amount of Charge after Modification is required
                    </div> -->
                    <div
                      *ngIf="(modForm.controls['amountOfCharge'].hasError('pattern')||modForm.controls['amountOfCharge'].hasError('maxlength')) && modForm.controls['amountOfCharge'].touched"
                      class="form-control-error-custom">
                      Amount of Charge after Modification is invalid
                    </div>
                  </div>
                </div>
                <div class="card-footer" align="right">
                  <div class="form-group">
                    <button *ngIf="!ismodified" class="btn btn-sm btn-primary" (click)="showFormEntryModification()"
                      type="button" [disabled]="!modForm.valid || disabledOnClick">Save</button>
  
  
                    <!-- <span style="float: right"> -->
                    <button type="button" class="btn btn-sm btn-primary" data-toggle="modal"
                      data-target="#modificationhistoryNew"
                      [appHasPermission]="{'Url': '/register/chg7List/edit?goveva=true&email=', 'method':'put', 'menu': 'chg7List'}"
                      *ngIf="ismodified" (click)="getBankChargeMasterById(editChargeID)">
                      <i class="icmn-history"></i>Modification History</button>
                    <!-- </span> -->
  
  
                    <button *ngIf="ismodified" class="btn btn-sm btn-primary" (click)="showFormEntryModification()"
                      type="button" [disabled]="!modForm.valid || disabledOnClick">Update</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
  
          <div class="tab-pane" id="satisfaction" role="tabcard">
            <form [formGroup]='satForm' class="well" (document:click)="m.close();n.close()">
              <div class="modal-body">
                <div class="row">
                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label>Date of satisfaction</label>
                    <div class="input-group" (click)="$event.stopPropagation()">
                      <input class="form-control" [formControl]="satForm.controls['dateOfSatisfaction']"
                        [(ngModel)]="dateOfSatisfaction" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy"
                        name="satisfactiondate" ngbDatepicker #m="ngbDatepicker" (click)="m.toggle()">
                      <button class="input-group-addon" (click)="m.toggle()" type="button">
                        <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                      </button>
                    </div>
                  </div>
  
                  <div class="form-group col-md-4 col-sm-6 col-xs-12">
                    <label>Date of registration of satisfaction</label>
                    <div class="input-group" (click)="$event.stopPropagation()">
                      <input class="form-control" [formControl]="satForm.controls['dateOfRegSatisfaction']"
                        [(ngModel)]="dateOfRegSatisfaction" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy"
                        name="regsatisfactiondate" ngbDatepicker #n="ngbDatepicker" (click)="n.toggle()">
                      <button class="input-group-addon" (click)="n.toggle()" type="button">
                        <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                      </button>
                    </div>
                  </div>
                </div>
  
                <div class="card-footer" align="right">
                  <div class="form-group">
                    <button class="btn btn-sm btn-primary" (click)="showFormEntrySatisfaction()" *ngIf="!issatisfied"
                      type="button" [disabled]="!satForm.valid || disabledOnClick">Save</button>
                    <button class="btn btn-sm btn-primary" (click)="showFormEntrySatisfaction()" *ngIf="issatisfied"
                      type="button" [disabled]="!satForm.valid || disabledOnClick">Update</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
  
  
  
  
  
  
  
  
          <div class="modal fade modal-size-large" id="modificationhistoryNew" tabindex="-1" role="dialog"
            data-backdrop="static" data-keyboard="false" aria-labelledby="" aria-hidden="true">
            <div class="modal-dialog  modal-xl" role="document" style="max-width: 100% !important;">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="myModalLabel">
                    <i class="icmn-history"></i>&nbsp;Modification History</h5>
                  <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                    <i class="fa fa-times"></i>
                  </button>
                </div>
                <div class="card-block datatable-card-block">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="margin-bottom-50">
                        <div class="table-responsive">
                          <table datatable [dtOptions]="dtOptionsOfChargeMasterNew" [dtTrigger]="dtTriggerChargeMasterNew"
                            class="table table-hover compact cell-border nowrap stripe" id="modificationHistoryTable"
                            style="cursor: pointer;">
                            <thead>
                              <tr>
                                <th>Date of modification of charge</th>
                                <th style="display: none;">Date of modification of charge</th>
  
                                <th>Date of registration of modification of charge</th>
                                <th style="display: none;">Date of registration of modification of charge</th>
  
                                <th>Description of the instrument modifying the charge</th>
                                <th>Particulars of modification</th>
                                <th>Amount of Charge after Modification</th>
  
                                <th style="display: none;" class="actionclass">Action</th>
                              </tr>
                            </thead>
  
                            <tbody>
                              <tr *ngFor="let director of data;">
  
                                <td>
                                  <span>
                                    <span style="display: none">{{director.dateOfModification | date :"yMMdd"}}</span>
                                    {{director.dateOfModification | date : "dd-MM-y"}}
                                  </span>
                                </td>
                                <td style="display: none">
                                  <span>
                                    {{director.dateOfModification | date : "dd-MM-y"}}
                                  </span>
                                </td>
                                <td>
                                  <span>
                                    <span style="display: none">{{director.dateOfRegModification | date :"yMMdd"}}</span>
                                    {{director.dateOfRegModification | date : "dd-MM-y"}}
                                  </span>
                                </td>
                                <td style="display: none">
                                  <span>
                                    {{director.dateOfRegModification | date : "dd-MM-y"}}
                                  </span>
                                </td>
                                <td>
                                  <span>
                                    {{director.descOfInstrumentModifying}}</span>
                                </td>
                                <td>
                                  <span>
                                    {{director.particularsOfMod}}</span>
                                </td>
                                <td>
                                  <span>
                                    {{director.amountOfCharge}}</span>
                                </td>
                                <td style="display: none;">
                                  <div class="input-group">
                                    <button type="button" (click)="editChargedetail(director._id)"
                                      class="btn-sm btn btn-warning"
                                      [appHasPermission]="{'Url': '/register/chg7List/edit?goveva=true&email=', 'method':'put', 'menu': 'chg7List'}">
                                      <span class="fa fa-pencil"></span>
                                    </button>
                                    &nbsp;&nbsp;
                                    <button type="button" class="btn-sm btn btn-danger"
                                      delete-meeting="5cee33d225242e023acfb2d4"
                                      [appHasPermission]="{'Url': '/register/chg7List/edit?goveva=true&email=', 'method':'put', 'menu': 'chg7List'}"
                                      (click)="confirmDelete(director._id)">
                                      <span class="icmn-bin"></span>
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
  
                  <button type="button" class="btn btn-sm" data-dismiss="modal">
                    <i class="fa fa-times"></i>&nbsp;Close
                  </button>
                </div>
              </div>
            </div>
          </div>
  
  
  
  
  
        </div>
      </div>
    </div>
  </section>
  <app-alert></app-alert>